import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-41" data-mp="bq9furzo3c1a">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy/95 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:inset-x-auto md:bottom-6 md:right-6 md:rounded-2xl md:border-0 md:bg-transparent md:p-0 md:backdrop-blur-0" data-id="element-42" data-mp="195wrtb2xzn8w">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-xl bg-cta px-5 py-4 font-display text-base font-extrabold uppercase tracking-wide text-white shadow-[0_4px_0_0_#B84300,0_10px_24px_-6px_rgba(255,106,19,0.7)] hover:bg-cta-hover md:px-8" data-id="element-43" data-mp="21at6geaids5u">
            <span className="whitespace-nowrap" data-id="element-44" data-mp="1iejjt2ljjta8">Get it now for $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-45" data-mp="1ncl57u6fw4ov" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}